import React from 'react'

// @ts-ignore
import isMobile from '../helpers/isMobile'
import styles from './PropertyWithTitle.css'
// @ts-ignore
import RawFormattedMessage from './RawFormattedMessage'

interface PropertyWithTitleProps {
  children?: React.ReactNode
  className?: string
  isLabel?: boolean
  isList?: boolean
  labelFor?: string
  labelWithError?: boolean
  title: string
}

export default function PropertyWithTitle ({
  children,
  className,
  isLabel,
  isList = false,
  labelFor,
  labelWithError = false,
  title
}: PropertyWithTitleProps) {
  if (!children || !title) {
    return null
  }

  if (!isMobile() && isList) {
    return <div>{children}</div>
  }

  let ChildrenWrapper: keyof JSX.IntrinsicElements
  let MessageWrapper: keyof JSX.IntrinsicElements
  if (isMobile() && isList) {
    MessageWrapper = 'div'
    ChildrenWrapper = 'div'
  } else if (isLabel) {
    MessageWrapper = 'label'
    ChildrenWrapper = 'div'
  } else {
    MessageWrapper = 'dt'
    ChildrenWrapper = 'dd'
  }

  return (
    <div className={[styles.root, className].join(' ')}>
      <MessageWrapper
        className={[labelWithError ? styles.labelWithError : styles.label].join(
          ' '
        )}
        htmlFor={MessageWrapper === 'label' ? labelFor : undefined}
      >
        <RawFormattedMessage id={title} />
      </MessageWrapper>
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </div>
  )
}
